import { render, staticRenderFns } from "./thinktankMy.vue?vue&type=template&id=67301f67&scoped=true"
import script from "./thinktankMy.vue?vue&type=script&lang=js"
export * from "./thinktankMy.vue?vue&type=script&lang=js"
import style0 from "./thinktankMy.vue?vue&type=style&index=0&id=67301f67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67301f67",
  null
  
)

export default component.exports